module.exports = __webpack_public_path__ + "img/YesNo.4cde971b.svg";